<img class="max-h-14" src="{{item.media.mediaUrl}}" />


